import './App.css';
// import {
//   Select, Option, Button,
//   Dialog,
//   DialogHeader,
//   DialogBody,
//   DialogFooter,
// } from "@material-tailwind/react";
  import { BrowserRouter, Routes, Route } from "react-router-dom";
  import Form from './component/Form/Form';
  import SignIn from './component/SignIn/SignIn';
  import SignUp from './component/SignUp/SignUp';
  import Admin from './admin';
  import Payment from './component/payment/payment';
  import PaymentTable from './component/Dashboard/pay';
import RegisteredStd from './pages/registeredStd';
import DownloadPage from './pages/DownloadPage';



function App() {
  return (
    <>


      <BrowserRouter>

        <Routes>
          <Route path="/" element={<Form />} />
          <Route path="/download" element={<DownloadPage />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/dashboard" element={<Admin />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/veiwpayment" element={<PaymentTable />} />
          <Route path="/registeredstd" element={<RegisteredStd />} />
        </Routes>
      </BrowserRouter>

      {/* <Admin /> */}

    </>

  );

 






}

export default App;
